<template>
  <!-- QUIZ MOBILE AND TABLET -->
  <div
    v-if="$store.getters.isMobile || $store.getters.isTablet"
    class="c-greeting-mission__quiz__info"
  >
    <div class="c-greeting-mission__quiz__col">
      <div class="c-greeting-mission__quiz__box">
        <h4 class="c-greeting-mission__quiz__count text-primary">
          {{ questions || 0 }}
        </h4>
        <div class="c-greeting-mission__quiz__count-title text-primary">
          {{ $t("Numero di domande") }}
        </div>
      </div>
    </div>
    <div class="c-greeting-mission__quiz__col">
      <div class="c-greeting-mission__quiz__box">
        <h4 class="c-greeting-mission__quiz__count">{{ time || 0 }}s</h4>
        <div class="c-greeting-mission__quiz__count-title">
          {{ $t("Tempo Totale") }}
        </div>
      </div>
    </div>
  </div>
  <!-- QUIZ MOBILE AND TABLET END -->

  <!-- QUIZ DESKTOP -->
  <div v-else class="c-greeting-mission__quiz__info">
    <div
      class="c-greeting-mission__quiz__col c-greeting-mission__quiz__col--desktop text-primary"
    >
      <div class="desktop__icon" v-html="questionMark"></div>
      <h4 class="desktop__title">
        ({{ $t("Numero di domande") }}: {{ questions || 0 }})
      </h4>
      <div class="desktop__border btn-primary"></div>
    </div>
    <div
      class="c-greeting-mission__quiz__col c-greeting-mission__quiz__col--desktop text-primary"
    >
      <div class="desktop__icon" v-html="hourglassIcon"></div>
      <h4 class="desktop__title">
        ({{ $t("Tempo Totale") }}: {{ time || 0 }}s)
      </h4>
    </div>
  </div>
  <!-- QUIZ DESKTOP END -->
</template>

<script>
import questionMark from "@/assets/svg/rebuild/domande_icon.svg";
import hourglassIcon from "@/assets/svg/rebuild/tempo_icon.svg";
export default {
  name: "GreetingQuizSlot",
  props: ["questions", "time"],
  data() {
    return {
      questionMark,
      hourglassIcon
    };
  }
};
</script>

<style lang="scss" scoped>
.c-greeting-mission__quiz__info {
  display: flex;
  width: 100%;
  margin: 20px 0 50px 0;
  justify-content: center;
}
.c-greeting-mission__quiz__col {
  flex: 0 0 50%;
  max-width: 50%;
  padding: 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.c-greeting-mission__quiz__box {
  padding: 15px 0 45px 0;
  text-align: center;
  border-radius: 20px;
  position: relative;
  height: 100px;
  background: #e0e3f9;
  width: 120px;
}
.c-greeting-mission__quiz__count {
  font-size: 25px;
  font-weight: bold;
}
.c-greeting-mission__quiz__count-title {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  border-radius: 20px;
  height: 45px;
  line-height: 45px;
}

//quiz desktop
.c-greeting-mission__quiz__col--desktop {
  position: relative;
  margin: 0 15px;
  &:first-of-type {
    justify-content: flex-end;
  }
  &:last-of-type {
    justify-content: flex-start;
  }
}
.desktop__icon {
  margin-right: 15px;
}
.desktop__border {
  position: absolute;
  right: -15px;
  top: -5px;
  height: 41px;
  width: 2px;
}
</style>
